import script from "./ShopListGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopListGrid.vue?vue&type=script&lang=ts&setup=true"

import "./ShopListGrid.vue?vue&type=style&index=0&id=43e1a291&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e1a291"]])

export default __exports__